<p>dedupe works!</p>
